import apiClient, {authHeaders} from './config.js';

export default {
  async getUsers(token, pageSize, page, searchQuery) {
    return await apiClient.get(
      `users/?skip=${page}&limit=${pageSize}&search=${searchQuery}`,
      authHeaders(token));
  },
  async getUserDetail(token, userId) {
    return await apiClient.get(`users/${userId}/detail`, authHeaders(token));
  },
  async createUser(token, userData) {
    return await apiClient.post('users/create/', userData, authHeaders(token));
  },
  async updateUser(token, userData) {
    return await apiClient.post('users/update_user', userData, authHeaders(token));
  },
  async deleteUser(token, userId) {
    return await apiClient.delete(`users/${userId}`, authHeaders(token));
  },
};
